module.exports = __webpack_public_path__ + "img/usercard.49542222.png";